import { Flex, Spacing } from '@billy/design-system'

import { ExpandedRowsContextProvider } from '../../../contexts/expandedRowsContext'
import { ProfitAndLossActions } from './components/ProfitAndLossActions'
import { ProfitAndLossTable } from './components/ProfitAndLossTable'
import { useProfitAndLossData } from './hooks/useProfitAndLossData'

export const ProfitAndLossReport = () => {
  const { allExpandableIds } = useProfitAndLossData()

  return (
    <ExpandedRowsContextProvider allExpandableIds={allExpandableIds}>
      <Flex gap={Spacing.S16} flexDirection="column">
        <ProfitAndLossActions />
        <ProfitAndLossTable />
      </Flex>
    </ExpandedRowsContextProvider>
  )
}
